import { useHistory, useParams } from "react-router";
import { DOCUMENT_UPLOAD_DETAIL_TAB_NAME } from "common/constants";
import { buildLink } from "common/routing";
import { useGeocodeDocumentUploadMutation } from "../../generated/graphql";
import { useStatusToasts } from "../../hooks/useStatusToasts";
import { Button } from "../Common/Button";
import PropertyForm, { ActionProps, FormData } from "../Property/PropertyForm";

const GeocodeDocument = () => {
  const { id: documentUploadId } = useParams<{ id: string }>();
  const { addSuccessToast, addErrorToast } = useStatusToasts();
  const history = useHistory();

  const [geocodeDocumentUpload, { loading }] = useGeocodeDocumentUploadMutation(
    {
      onCompleted: () => {
        addSuccessToast("Document geocoded successfully");
        history.push(
          buildLink(
            "documentUploadDetail",
            {
              id: documentUploadId,
            },
            {
              tab: DOCUMENT_UPLOAD_DETAIL_TAB_NAME.LOCATION,
              fetchPolicy: "network-only",
            },
          ),
        );
      },
      onError: error => {
        addErrorToast(error.message);
      },
    },
  );

  const onSave = async (formData: FormData) => {
    await geocodeDocumentUpload({
      variables: {
        documentUploadId: documentUploadId,
        geocodeData: {
          propertyId: formData.propertyId,
          address: formData.address,
          geocacheParcelId: formData.geocacheParcelId,
          latitude: formData.latitude,
          longitude: formData.longitude,
        },
      },
    });
  };

  const actions = (props: ActionProps): JSX.Element => {
    return (
      <Button
        size="small"
        styleVariant="primary"
        onClick={() =>
          props.validateInput((data: FormData) => {
            return onSave(data);
          })
        }
        disabled={loading || props.disabled}
      >
        Add
      </Button>
    );
  };

  return (
    <PropertyForm
      property={null}
      point={null}
      parcel={null}
      zoom={null}
      actions={actions}
      error={null}
      headerText={"Add location"}
      title={"Add location"}
      subtitle={
        "Provide a few details on the property's address and select a location on the map."
      }
      warningsComponent={() => <></>}
      canSubmitProperty={true}
      editingProperty={false}
    />
  );
};

export default GeocodeDocument;
